import { FETCH_SUCCESS, FETCH_START, FETCH_FAILURE } from './actionTypes'

export const fetchSuccess = categories => ({
  type: FETCH_SUCCESS,
  categories
})

export const fetchStart = () => ({
  type: FETCH_START
})

export const fetchFail = error => ({
  type: FETCH_FAILURE,
  error
})
